import { render, staticRenderFns } from "./RichEditorMenuBubble.vue?vue&type=template&id=c164a58c&scoped=true"
import script from "./RichEditorMenuBubble.vue?vue&type=script&lang=js"
export * from "./RichEditorMenuBubble.vue?vue&type=script&lang=js"
import style0 from "./RichEditorMenuBubble.vue?vue&type=style&index=0&id=c164a58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c164a58c",
  null
  
)

export default component.exports